module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADiSURBVDiNrZPBVcMwEET/GMlcXYrpgDtVuAJogQpSQiiBAz4TKkjSgenA5yh4OJiXR0KQ4wdzk3bn72olqY2xRl6CK2ZJPVajtgxroJ5nPmhTzK/8Xa6KiYQO0+cyQt7P4yD3BSzGtSrEUcc/AdbNXUqbk91ngDbGGrzOAnYp9S8xvErcYjcASEub1S6lpiyPLRMzmNbZGUissLvB6sYqfoJiexHgOoZ721vgfR/2HUD5cfUmhjE2BbB4APFlPMwA4NT86xEOMIoKQGetFwAkL3Jx/uMWClD2qealPmA1f/nOn5FFUMJpe3BVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh.png
// module id = 3Nc4
// module chunks = 1